module.exports = __webpack_public_path__ + "static/media/mindset_shift.c325480d.webp";